import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { sendEmail } from 'api/auth'
import Sidebar from 'components/Sidebar'
import Input from 'components/UI/Input'
import PhoneInput from 'components/UI/PhoneInput'
import { optionsParser, t } from 'helpers'
import { basicFields, contactFields } from 'pages/Portfolio/fields'
import { notif } from 'helpers/notif'
import { AttributeSelector } from 'types/app'
import { DROPDOWN_OPTIONS } from 'types/enums'
import Select from 'components/UI/Select'

const agencyProfessionField: AttributeSelector = {
	name: 'Customer:Profession',
	label: 'APP_WORK_TYPE_LABEL',
	type: 'select',
	optionName: DROPDOWN_OPTIONS.AGENCY_PROFESSIONS,
	options: [],
}
const cdProfessionField: AttributeSelector = {
	name: 'Customer:Profession',
	label: 'APP_WORK_TYPE_LABEL',
	type: 'select',
	optionName: DROPDOWN_OPTIONS.CD_PROFESSIONS,
	options: [],
}

const voucherField: AttributeSelector = {
	name: 'Custom:VoucherCode',
	label: 'APP_VOUCHER_CODE_LABEL',
	type: 'input',
	options: [],
}

const agencyFields = [
	agencyProfessionField,
	basicFields.name,
	contactFields.email,
	contactFields.website,
	contactFields.phone,
	voucherField,
]

const directorFields = [
	cdProfessionField,
	basicFields.name,
	contactFields.imdb,
	contactFields.email,
	contactFields.phone,
	voucherField,
]

const RegisterAsSidebar = (): JSX.Element => {
	const { search } = useLocation()
	const navigate = useNavigate()
	const [values, setValues] = useState<{ [key: string]: string }>({})

	const type = new URLSearchParams(search).get('as')

	const fields = type === 'agency' ? agencyFields : directorFields

	useEffect(() => {
		if (!type) setValues({})
	}, [type])

	return (
		<Sidebar
			open={type === 'agency' || type === 'director'}
			onClose={() => {
				navigate(window.location.pathname)
			}}
			header={{
				title: `APP_REGISTER_AS_${type?.toUpperCase()}_SIDEBAR_TITLE`,
				description: `APP_REGISTER_AS_${type?.toUpperCase()}_SIDEBAR_DESCRIPTION`,
			}}
			buttons={[
				{
					children: t('APP_DONE'),
					onClick: async () => {
						try {
							const body = `New ${type} registration request<br />Local Date<br />${new Date().toISOString()}${fields?.map(
								(field) => `<br />${t(field.label)}<br />${values[field.name]}`,
							)}`
							await sendEmail(
								'New registration request' +
									' at ' +
									dayjs().format('MM-DD-YYYY HH:mm'),
								body,
							)
							notif('success', t('APP_SENDED_REQUEST_SUCCESSFULLY'))
						} catch (error) {
							console.log('error:', error)
							notif('error', t('APP_SOMETHING_WENT_WRONG'))
						} finally {
							navigate(window.location.pathname)
						}
					},
					disabled:
						Object.values(values)?.filter((v) => !!v)?.length !==
						fields?.length,
				},
			]}>
			<>
				{fields?.map((field) =>
					field.type === 'phone' ? (
						<PhoneInput
							key={field.name}
							label={field.label}
							name={field.name}
							onPhoneChange={(phone) => {
								if (phone && phone !== '') {
									setValues((prev) => ({
										...prev,
										[field.name]: phone === '+' ? '' : phone,
									}))
								}
							}}
							defaultValue={''}
						/>
					) : field.type === 'select' ? (
						<Select
							key={field.name}
							name={field.name}
							label={field.label}
							options={optionsParser(field.optionName || '')}
							inputProps={{ value: values[field.name || ''] }}
							onChange={(e) => {
								setValues((prev) => ({
									...prev,
									[field.name]: e.target.value,
								}))
							}}
						/>
					) : (
						<Input
							key={field.name}
							name={field.name}
							label={field.label}
							onChange={(e) => {
								setValues((prev) => ({
									...prev,
									[field.name]: e.target.value,
								}))
							}}
						/>
					),
				)}
			</>
		</Sidebar>
	)
}

export default RegisterAsSidebar
